import { OnEventDispatcher } from "../../core/on-event-dispatcher";
import { StateManagerEventData } from "../../core/statemanager";
import { GADataLayer } from "../../io/gadatalayer";
import { Application } from "../../main";

export class MenuView extends OnEventDispatcher {

    elm: JQuery<HTMLElement>;
    inner: JQuery<HTMLElement>;
    menuItems: JQuery<HTMLElement>;
    bottomMenuItems: JQuery<HTMLElement>;

    constructor(container:JQuery<HTMLElement>) {
        super();

        this.elm = container.find("> .menu-view");
        this.inner = this.elm.find(".menu-view-inner");
        this.menuItems = this.inner.find("a.menu-item");
        this.bottomMenuItems = this.inner.find("bottom-menu-item > a");


        Application.stateManager.on("change", async (_ev:string, data:StateManagerEventData) => {
            this.elm.find("a").removeClass("active");
            this.elm.find('a[href="'+data.path+'"]').addClass("active");
        });
        this.elm.find("a").each((_index:number, helm:HTMLElement) => {
            let elm = $(helm);
            let href:string = elm.attr("href");
            let isInternal:boolean = ((href.indexOf("/")==0&&href.indexOf("//")!=0&&href.indexOf("http")!=0)) || (href.indexOf("#")==0||href.indexOf("javascript:")==0);
            if(!isInternal) {
                elm.attr("target", "_blank");
            }
            elm.on("click", (e:any) => {
                GADataLayer.link_click(href, window.location.pathname, elm.attr("id"), elm.attr("class"));
                if(isInternal && href.indexOf("#")!=0 && href.indexOf("javascript:")!=0) {
                    e.preventDefault();
                    e.stopPropagation();
                    Application.stateManager.setPath(href);
                    return false;
                }
            });
        });
    }

    async open() {
        $("body").addClass("menu-view-open");
        Application.events.dispatch("open_menuview");
    }
    close(silent:boolean = false) {        
        $("body").removeClass("menu-view-open");
        Application.events.dispatch("close_menuview");
    }

    toggle() {
        if($("body").hasClass("menu-view-open")) {
            this.close();
        } else {
            this.open();
        }
    }

}